import { Image, ImageProps } from "antd-mobile";
import React from "react";

const CustomImage = ({ onError, src, ...props }: ImageProps) => {
    const [isError, setIsError] = React.useState(false);

    const onErrorHandler = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
        console.log(9900);
        if (typeof onError === "function") onError(event);
        setIsError(true);
    };
    if (isError) {
        return (
            <div className="flex h-[100%] flex-col items-center justify-center text-center">
                <i className="iconfont icon-Wheel_chouma text-[.3rem] text-[#3b4750]"></i>
                <span className="text-[.12rem] leading-[1] text-[#3b4750]">
                    Falha no carregamento
                </span>
            </div>
        );
    }
    // eslint-disable-next-line jsx-a11y/alt-text
    return <Image {...props} src={src} onError={onErrorHandler}></Image>;
};

export default CustomImage;
